"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invoice = void 0;
// @todo this file is not used anywhere, delete next time
class Invoice {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        Object.assign(this, input);
        return this;
    }
}
exports.Invoice = Invoice;
